import React from 'react';
// eslint-disable-next-line import/no-anonymous-default-export
const { version } = require('../../package.json');

const Impressum = () => {
  return (
    <div className="drawer-page">
      <h1 className="impressum__title">Impressum</h1>

      <div className="card impressum__card">
        <h2 className="impressum__section-title">Angaben gemäß § 5 TMG</h2>

        <div className="impressum__groups">
          <div>
            <h3 className="impressum__group-title">Betreiber</h3>
            <p className="impressum__address">Grosskinder Aktiv</p>
            <p className="impressum__address">Hermann Pätzold</p>
            <p className="impressum__address">Schönholzweg 45</p>
            <p className="impressum__address">8409 Winterthur</p>
            <p className="impressum__address">Schweiz</p>
          </div>

          <div>
            <h3 className="impressum__group-title">Kontakt</h3>
            <p className="impressum__address">E-Mail: hello@grosskinder-aktiv.ch</p>
            <p className="impressum__address">Telefon: +41 79 254 05 63</p>
          </div>

          <div>
            <h3 className="impressum__group-title">Verantwortlich für den Inhalt</h3>
            <p className="impressum__text">Grosskinder Aktiv Team</p>
          </div>

          <div>
            <h3 className="impressum__group-title">Haftungsausschluss</h3>
            <p className="impressum__disclaimer">
              <strong>Aktualität und Richtigkeit der Inhalte: </strong>
              Die Inhalte auf dieser Plattform werden mit grösstmöglicher Sorgfalt erstellt und gepflegt.
              Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte – insbesondere von
              Veranstaltungsdaten, Öffnungszeiten und Preisangaben – kann jedoch keine Gewähr
              übernommen werden. Wir empfehlen, wichtige Angaben vor einem Besuch direkt beim Anbieter
              zu überprüfen.
            </p>
            <p className="impressum__disclaimer">
              <strong>ÖV-Verbindungen: </strong>
              Die angezeigten Fahrpläne und Verbindungszeiten stammen aus der SBB OpenData API und
              werden zu Orientierungszwecken bereitgestellt. Sie können zwischenzeitlich veraltet sein
              oder kurzfristige Änderungen wie Verspätungen oder Ausfälle nicht berücksichtigen.
              Für aktuelle Fahrplaninformationen empfehlen wir die offizielle SBB-App oder sbb.ch.
              Eine Haftung für Schäden, die aus der Nutzung ungenauer Fahrplandaten entstehen, wird
              ausgeschlossen.
            </p>
            <p className="impressum__disclaimer">
              <strong>Externe Links: </strong>
              Unsere Plattform enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
              Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr
              übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
              Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
              Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
              Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der
              verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht
              zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend
              entfernen.
            </p>
          </div>
        </div>
      </div>

      <p className="impressum__version">Version {version}</p>
    </div>
  );
};

export default Impressum;
